<template>
  <div>
    <van-uploader style="background: #d1ebf6;margin: 0 3%; width: 94%;overflow: hidden;" :after-read="afterRead"
      :before-read="beforeRead" :accept="accept" :disabled="disabled" @delete="beforeDelete" v-model="uploader" multiple>
      <div class="van-uploader__text">
        <div class="van-uploader__text-content">
          <van-icon class="van-uploader__icon" name="photograph" />
        </div>
        <div class="van-uploader__text-tip">
          请上传您的相关证件照片
        </div>
      </div>
    </van-uploader>
  </div>
</template>
 
<script>
import { uploaderFile } from "@/api/index";
import { Toast } from "vant";
export default {
  props: {
    value: {
      default: undefined,
    },
    //  上传的文件类型
    accept: {
      type: String,
      default: "*",
    },
    //  是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageList: [], // 上传完成后接口返回的路径
      uploader: [], // 上传完成组件返回的文件信息
    };
  },
  methods: {
    // 删除文件
    beforeDelete(file, detail) {
      // 把需要删除的项根据下标删除
      this.imageList.splice(detail.index, 1);
      // 返回最新的数组 并转换成以逗号隔开的格式   如果不需要去掉即可
      this.$emit("input", this.imageList.join(","));
    },
    //  上传之前要做的校验
    beforeRead(files) {
      // Ensure files is an array (it could be a single file)
      if (!Array.isArray(files)) {
        files = [files];
      }
      // Print the files to the console
      console.log(files);
      // this.accept is the allowed file format(s), separated by commas
      const arr = this.accept.split(",");
      // If the array contains "*", any file type is acceptable
      if (arr.includes("*")) {
        return true;
      } else {
        // Check each file's type
        for (let file of files) {
          // If the file type is not in the allowed formats, show a toast message and return false
          if (!arr.includes(file.type)) {
            Toast(`请上传${this.accept}格式的文件！`);
            return false;
          }
        }
        // If all files meet the criteria, return true
        return true;
      }
    },
    // 上传文件请求
    afterRead(files) {
      // Ensure files is an array (it could be a single file)
      if (!Array.isArray(files)) {
        files = [files];
      }

      // Iterate over each file to handle the upload process
      files.forEach(file => {
        // Set initial upload status
        file.status = "uploading";
        file.message = "上传中...";

        // Convert the file into the format required by the API
        const formData = new FormData();
        formData.append("file", file.file);

        // Make the API request
        uploaderFile(formData)
          .then(res => {
            // Update status to success upon successful upload
            file.status = "done";
            // Add the response data to the image list
            this.imageList.push(res);
            // Emit the updated image list as a comma-separated string (if needed)
            this.$emit("input", this.imageList.join(","));
          })
          .catch(err => {
            console.log(err);
            // Update status to failed if the upload fails
            file.status = "failed";
            file.message = "上传失败";
          });
      });
    }

  },
};
</script>
<style  lang="less">
.van-uploader__text {
  width: 100vw;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;

}

.van-uploader__text-content {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  font-size: 60px;
  background: #fff;
  position: relative;

  .van-uploader__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #7f7f7f;
  }
}

.van-uploader__text-tip {
  position: absolute;
  top: 80%;
}
</style>